import type { ButtonHTMLAttributes, Ref } from "react";
import "./toggle-button.css";

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-pressed"> & {
  /** Acceso o spento: lo dice `aria-pressed`, e si vede con bordo e fondo d'accento. */
  pressed: boolean;
  /** Arriva al `<button>` (in React 19 `ref` è una prop). */
  ref?: Ref<HTMLButtonElement>;
};

// Un pulsante a pillola che si accende e si spegne (un filtro: «Chiamate», «Note»). Più pillole insieme stanno in un
// contenitore con `role="group"` e un nome. Se si sceglie una sola cosa fra poche e il Tab deve fermarsi una volta,
// si usa `Segmented`.
export function ToggleButton({ pressed, type = "button", className, ...rest }: Props) {
  return <button type={type} className={className ? `g-toggle ${className}` : "g-toggle"} aria-pressed={pressed} {...rest} />;
}
